import { MoreVertOutlined, Search } from "@mui/icons-material";
import { Grid2, TableCell, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DeleteIco from "../../../../assets/icons/DeleteIco";
import EyeIco from "../../../../assets/icons/EyeIco";
import Breadcrumbs from "../../../../component/Breadcrumbs";
import CommonButton from "../../../../component/Button";
import CommonTextField from "../../../../component/Input";
import CustomMenuItem from "../../../../component/Menu";
import CommonTable from "../../../candidates/Table";
import {
  DotColor,
  StatusChange,
  StyledFlexRowView,
} from "../../../common-components/StyledComponents";
import { StyledSpaceBetweenBox } from "../../../matches/quick-match/components/StyledComponent";

function MySowTableList() {
  const navigate = useNavigate();
  const [selectedRows, setSelectedRows] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [sortedData, setSortedData] = useState([
    {
      id: "10000",
      projectName: "Project Atlantis",
      company: "Optum",
      owner: "Olivia Rhye",
      score: "92",
      status: "Review Pending",
      logo: "https://mui.com/static/images/avatar/3.jpg",
      invited: "5",
      proposals: "4",
    },
    {
      id: "10001",
      projectName: "Project Artemis",
      company: "Photon",
      owner: "Lana Steiner",
      score: "62",
      status: "Closed",
      logo: "https://mui.com/static/images/avatar/4.jpg",
      invited: "-",
      proposals: "-",
    },
    {
      id: "10002",
      projectName: "Project Alpha",
      company: "ABC Company",
      owner: "Orlando Diggs",
      score: "30",
      status: "Accepted",
      logo: "https://mui.com/static/images/avatar/2.jpg",
      invited: "7",
      proposals: "3",
    },
    {
      id: "10003",
      projectName: "Project Zeta",
      company: "ABC Company",
      owner: "Koray Okums",
      score: "60",
      status: "Closed",
      logo: "https://mui.com/static/images/avatar/1.jpg",
      invited: "5",
      proposals: "2",
    },
  ]);
  const headerData = [
    { name: "SoWs" },
    { name: "Project Name" },
    { name: "Invited" },
    { name: "Proposals" },
    { name: "Status" },
    "",
  ];

  const sortableColumns = ["SoWs"];

  const handleRowCheckboxChange = (rowId) => {
    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.includes(rowId)
        ? prevSelectedRows.filter((id) => id !== rowId)
        : [...prevSelectedRows, rowId]
    );
  };

  const handleIconClick = (event, rowData) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const menuData = [
    // {
    //   title: "Edit",
    //   image: <AddUsersIco />,
    //   // onClick: () => navigate(`/proposal-view?isEdit=true`),
    // },
    // {
    //   title: "Generate Proposal",
    //   image: <ScalesIco />,
    //   //   disabled: true,
    //   // onClick: handleOpenActiveJobDialog,
    //   onClick: () => navigate(`/proposal-generator-view`),
    // },
    {
      title: "View Proposals",
      image: <EyeIco />,
      onClick: () => navigate(`/proposal-list`),
    },
    {
      title: "Delete Proposal",
      image: <DeleteIco />,
      // onClick: () => navigate(`/proposal-view?isEdit=true`),
    },
    // {
    //   title: "Compare Proposal to SoW",
    //   image: <UsersIco color={"#667085"} isHeight={"16"} isWidth={"16"} />,
    //   //   onClick: () => navigate(`/candidate-hub?resume=parse`),
    // },
  ];

  const handleTableBodyData = (row, index) => {
    return (
      <>
        {/* <TableCell>{row.id}</TableCell> */}
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.id}
        </TableCell>
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.projectName}
        </TableCell>
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.invited}
        </TableCell>
        <TableCell sx={{ color: "#101828", fontWeight: 500, fontSize: "16px" }}>
          {row.proposals}
        </TableCell>

        {/* <TableCell align="left" width={"20%"}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <CommonLinearProgress
                variant="determinate"
                value={row.score}
                flex={1}
                height={"8px"}
                borderRadius={"4px"}
                barbackgroundColor={getColor(row.score)}
              />
              <Typography>{row.score}%</Typography>
            </div>
          </TableCell> */}
        <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.status === "Accepted"
                  ? "#17B26A"
                  : row.status === "Review Pending"
                  ? "#9E77ED"
                  : row.status === "Available" || row.status === "Active"
                  ? "green"
                  : "#F04438"
              }
            />

            <div>{row.status}</div>

            {/* <IconButton sx={{ padding: 0 }}>
                <ChevronDownIco width={"16px"} height={"16px"} />
              </IconButton> */}
          </StatusChange>
        </TableCell>

        <TableCell>
          {/* <VisibilityOutlinedIcon
              onClick={() => handleIconClick(row)}
              style={{ cursor: "pointer" }}
            /> */}
          <MoreVertOutlined
            style={{ cursor: "pointer" }}
            onClick={(e) => handleIconClick(e, row)}
          />
          <CustomMenuItem
            open={open}
            anchorEl={anchorEl}
            handleMenuClose={handleMenuClose}
            menuData={menuData}
            boxShadow={
              "0px 0px 0px 0px rgba(16, 24, 40, 0.08),0px 3px 5px -3px rgba(16, 24, 40, 0.03)"
            }
          />
        </TableCell>
      </>
    );
  };
  return (
    <Grid2 container spacing={3} padding={"2rem"}>
      <Grid2 size={12}>
        <Breadcrumbs
          breadCrumbData={[
            // { title: "Bidding Engine" },
            { title: "My SoWs", active: true },
          ]}
        />
      </Grid2>
      <Grid2 size={12}>
        <StyledSpaceBetweenBox>
          <Typography variant="h2">{"My SoWs"}</Typography>

          <StyledFlexRowView>
            <CommonTextField
              placeholder="Search"
              startIcon={<Search />}
              // value={titleValue}
              // onChange={handleSearchInput}
            />
            <CommonButton
              variant="outlined"
              color="#344054"
              border="#D0D5DD"
              fontWeight="600"
              value="Filters"
              // onClick={() => setFilterPopup(true)}
            />
          </StyledFlexRowView>
        </StyledSpaceBetweenBox>
      </Grid2>
      <Grid2 size={12}>
        <CommonTable
          data={sortedData}
          columns={headerData}
          sortedColumns={sortableColumns}
          onSortChange={(col) => console.log("Sort by", col)}
          onRowCheckboxChange={handleRowCheckboxChange}
          handleTableBodyData={handleTableBodyData}
          //   withCheckbox={true}
        />
      </Grid2>
    </Grid2>
  );
}

export default MySowTableList;
